let nowClientWidth = document.documentElement.clientWidth;
window.nowSize = function(val, initWidth = 1920) {
    return val * (nowClientWidth / initWidth);
};


